import request from '@/utils/request'

export function findBaseCpeProducts(params) {
  return request({
    url: `/base_cpe_products`,
    method: 'get',
    params
  })
}

export function findImportableBaseCpeProducts(params) {
  return request({
    url: `/base_cpe_products/importable`,
    method: 'get',
    params
  })
}

export function createBaseCpeProduct(data) {
  return request({
    url: `/base_cpe_products`,
    method: 'post',
    data
  })
}

export function findBaseCpeProductForm(id) {
  return request({
    url: `/base_cpe_products/${id}/form`,
    method: 'get'
  })
}

export function updateBaseCpeProduct(id, data) {
  return request({
    url: `/base_cpe_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateBaseCpeProductsEffective(ids, effective) {
  return request({
    url: `/base_cpe_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
